<template>
  <v-container fluid pt-10>
    <v-layout wrap row pa-2>
      <v-flex sm12 md12 lg12>
        <v-card
          style="height: 100%; border-top: solid; border-top-color: #10303D; border-top-width: 3px;"
        >
          <v-flex sm12 md12 lg12 pa-4>
            <v-layout row wrap>
              <v-flex xs12 md3 lg2 pl-4>
                <v-autocomplete
                  v-model="sgFiltroDataAmbiencia"
                  :items="tiposFiltroDataAmbiencia"
                  @change="changeFiltroAmbiencia"
                  color="primary"
                  item-text="dsTipoFiltroDataTemperatura"
                  item-value="sgTipoFiltroDataTEmperatura"
                  label="Selecione o período para exibição"
                  outlined
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                sm6
                lg11
                pa-2
                pl-4
                v-if="tipoAmbiencia == 'TE' || tipoAmbiencia == 'TD'"
              >
                <span style="font-family: Roboto,sans-serif; font-size: 16px;"
                  >Temperatura</span
                >
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                v-if="
                  exibeGrafico &&
                    (tipoAmbiencia == 'TE' || tipoAmbiencia == 'TD')
                "
                pa-2
                pr-4
              >
                <LoteProducaoTemperaturaGrafico :values="listaTemperatura" />
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                v-if="
                  !$vuetify.breakpoint.xs &&
                    (tipoAmbiencia == 'TE' || tipoAmbiencia == 'TD')
                "
                pa-2
              >
                <v-data-table
                  dense
                  :headers="headersTemperatura"
                  hide-default-footer
                  disable-sort
                  no-results-text="Nenhum registro encontrado"
                  :items="registrosTabelaTemperatura"
                  color="secondary"
                  loading-text="Carregando registros...aguarde"
                >
                  <template v-slot:item.color="{ item }">
                    <v-chip
                      style="height:10px;"
                      :color="getColorTemperatura(item.name)"
                    ></v-chip>
                  </template>
                </v-data-table>
              </v-flex>

              <v-flex sm6 lg12 pa-2 pt-4 v-if="tipoAmbiencia == 'TD'">
                <v-divider />
              </v-flex>

              <v-flex
                sm6
                lg11
                pa-2
                pl-4
                v-if="tipoAmbiencia == 'CO' || tipoAmbiencia == 'TD'"
              >
                <span style="font-family: Roboto,sans-serif; font-size: 16px;"
                  >Cortina Direita</span
                >
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                v-if="
                  exibeGrafico &&
                    (tipoAmbiencia == 'CO' || tipoAmbiencia == 'TD')
                "
                pa-2
                pr-4
              >
                <LoteProducaoCortinaGrafico :values="listaCortinaDireita" />
              </v-flex>

              <v-flex
                sm6
                lg12
                pa-2
                pt-4
                v-if="tipoAmbiencia == 'CO' || tipoAmbiencia == 'TD'"
              >
                <v-divider />
              </v-flex>
              <v-flex sm6 lg11 pa-2 pl-4 v-if="tipoAmbiencia == 'CO'">
                <span style="font-family: Roboto,sans-serif; font-size: 16px;"
                  >Cortina Esquerda</span
                >
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                v-if="
                  exibeGrafico &&
                    (tipoAmbiencia == 'CO' || tipoAmbiencia == 'TD')
                "
                pa-2
                pr-4
              >
                <LoteProducaoCortinaGrafico :values="listaCortinaEsquerda" />
              </v-flex>

              <v-flex sm6 lg12 pa-2 pt-4 v-if="tipoAmbiencia == 'TD'">
                <v-divider />
              </v-flex>
              <v-flex
                sm6
                lg11
                pa-2
                pl-4
                v-if="tipoAmbiencia == 'UM' || tipoAmbiencia == 'TD'"
              >
                <span style="font-family: Roboto,sans-serif; font-size: 16px;"
                  >Umidade</span
                >
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                v-if="
                  exibeGrafico &&
                    (tipoAmbiencia == 'UM' || tipoAmbiencia == 'TD')
                "
                pa-2
                pr-4
              >
                <LoteProducaoUmidadeGrafico :values="listaUmidade" />
              </v-flex>

              <v-flex sm6 lg12 pa-2 pt-4 v-if="tipoAmbiencia == 'TD'">
                <v-divider />
              </v-flex>
              <v-flex
                sm6
                lg11
                pa-2
                pl-4
                v-if="tipoAmbiencia == 'GS' || tipoAmbiencia == 'TD'"
              >
                <span style="font-family: Roboto,sans-serif; font-size: 16px;"
                  >Concentração de Gás</span
                >
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                v-if="
                  exibeGrafico &&
                    (tipoAmbiencia == 'GS' || tipoAmbiencia == 'TD')
                "
                pa-2
                pr-4
              >
                <LoteProducaoCO2Grafico :values="listaCO2" />
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                v-if="
                  !$vuetify.breakpoint.xs &&
                    (tipoAmbiencia == 'GS' || tipoAmbiencia == 'TD')
                "
                pa-2
              >
                <v-data-table
                  dense
                  :headers="headersCO2"
                  hide-default-footer
                  disable-sort
                  no-results-text="Nenhum registro encontrado"
                  :items="registrosTabelaCO2"
                  color="secondary"
                  loading-text="Carregando registros...aguarde"
                >
                  <template v-slot:item.color="{ item }">
                    <v-chip
                      style="height:10px;"
                      :color="getColorCO2(item.name)"
                    ></v-chip>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-start ma-2>
              <v-btn
                id="return"
                rounded
                @click="voltar"
                style="background-color:#e8e8e8;"
              >
                <span class="marginSpan"> Voltar </span>
                <v-icon small>fa-arrow-left</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoteProducaoTemperaturaGrafico from "@/components/loteProducao/LoteProducaoTemperaturaGrafico.vue";
import LoteProducaoCortinaGrafico from "@/components/loteProducao/LoteProducaoCortinaGrafico.vue";
import LoteProducaoUmidadeGrafico from "@/components/loteProducao/LoteProducaoUmidadeGrafico.vue";
import LoteProducaoCO2Grafico from "@/components/loteProducao/LoteProducaoCO2Grafico.vue";
import { dateLocalToIso } from "@/filters/utils";

export default {
  name: "AmbienciaTudo",
  components: {
    LoteProducaoTemperaturaGrafico,
    LoteProducaoCortinaGrafico,
    LoteProducaoUmidadeGrafico,
    LoteProducaoCO2Grafico,
  },
  data() {
    return {
      tipoAmbiencia: "",
      exibeGrafico: false,
      sgFiltroDataAmbiencia: "24",
      tiposFiltroDataAmbiencia: [
        {
          sgTipoFiltroDataTEmperatura: "24",
          dsTipoFiltroDataTemperatura: "Últimas 24 horas",
        },
        {
          sgTipoFiltroDataTEmperatura: "48",
          dsTipoFiltroDataTemperatura: "Últimas 48 horas",
        },
        {
          sgTipoFiltroDataTEmperatura: "72",
          dsTipoFiltroDataTemperatura: "Últimas 72 horas",
        },
        {
          sgTipoFiltroDataTEmperatura: "96",
          dsTipoFiltroDataTemperatura: "Últimas 96 horas",
        },
        {
          sgTipoFiltroDataTEmperatura: "TD",
          dsTipoFiltroDataTemperatura: "Todas as medições",
        },
      ],
      listaTemperatura: [],
      registrosTabelaTemperatura: [],
      headersTemperatura: [
        { text: "", value: "color", sortable: false, align: "end", width: 8 },
        { text: "Temperatura", value: "name", sortable: false, align: "start" },
        { text: "Mínima", value: "tMin", sortable: false },
        { text: "Máxima", value: "tMax", sortable: false },
        { text: "Média", value: "tMed", sortable: false },
      ],
      listaCortinaDireita: [],
      listaCortinaEsquerda: [],
      listaUmidade: [],
      listaCO2: [],
      registrosTabelaCO2: [],
      headersCO2: [
        { text: "", value: "color", sortable: false, align: "end", width: 8 },
        {
          text: "Concentração de Gás",
          value: "name",
          sortable: false,
          align: "start",
        },
        { text: "Mínima", value: "gMin", sortable: false },
        { text: "Máxima", value: "gMax", sortable: false },
        { text: "Média", value: "gMed", sortable: false },
      ],
    };
  },
  computed: {
    loteProducao() {
      return this.$store.state.loteProducaoAtual;
    },
    urlAPIAmbiencia() {
      return this.$store.state.urlAPIAmbiencia;
    },
  },
  methods: {
    dateLocalToIso,
    changeFiltroAmbiencia() {
      let query = {};
      query.nrCodigoOficial = this.loteProducao.jsonEstabelecimento.nrCodigoOficial;
      query.nrUnidadeExploracao = parseInt(
        this.loteProducao.jsonUnidadeExploracao.nrUnidadeExploracao
      );
      query.nrPavilhao = this.loteProducao.nrPavilhao;

      this.tipoAmbiencia = this.$route.params.tipo;

      var dtInicio = new Date();
      var dtFim = null;
      if (this.loteProducao.blLoteFechado) {
        dtInicio = new Date(
          this.dateLocalToIso(this.loteProducao.dtFechamentoLote) + "T12:00:00Z"
        );
        dtFim = new Date(
          this.dateLocalToIso(this.loteProducao.dtFechamentoLote) + "T12:00:00Z"
        );
      }
      if (this.sgFiltroDataAmbiencia == "24") {
        dtInicio.setDate(dtInicio.getDate() - 1);
      } else if (this.sgFiltroDataAmbiencia == "48") {
        dtInicio.setDate(dtInicio.getDate() - 2);
      } else if (this.sgFiltroDataAmbiencia == "72") {
        dtInicio.setDate(dtInicio.getDate() - 3);
      } else if (this.sgFiltroDataAmbiencia == "96") {
        dtInicio.setDate(dtInicio.getDate() - 4);
      } else {
        dtInicio.setDate(dtInicio.getDate() - this.loteProducao.nrDiasAlojado);
      }
      query.dtInicio = dtInicio.toISOString();
      if (dtFim != null) {
        query.dtFim = dtFim.toISOString();
      }
      this.loadDadosAmbiencia(this.loteProducao, query);
    },
    loadDadosAmbiencia(loteProducao, query) {
      var context = this;
      context.listaTemperatura = [];
      context.listaCortinaDireita = [];
      context.listaCortinaEsquerda = [];
      context.registrosTabelaTemperatura = [];
      context.listaUmidade = [];
      context.listaCO2 = [];
      context.registrosTabelaCO2 = [];
      context.exibeGrafico = false;
      this.$axios
        .get(this.urlAPIAmbiencia + "grandeza-ponto/", {
          params: query,
        })
        .then((response) => {
          if (response.data.length > 0) {
            var teValues = [];
            var tdValues = [];
            var tExternaValues = [];
            var tempIdealValues = [];
            var gasMinValues = [];
            var gasMaxValues = [];

            response.data.forEach(function(ponto) {
              if (
                ponto.cdGrandeza == "TE" ||
                ponto.cdGrandeza == "TD" ||
                (ponto.cdGrandeza == "T_EXTERNA" &&
                  (context.tipoAmbiencia == "TE" ||
                    context.tipoAmbiencia == "TD"))
              ) {
                var item = context.listaTemperatura.find(
                  (x) => x.cdMedida == ponto.cdMedida
                );
                if (item) {
                  if (ponto.vlMin != 0 && ponto.vlMax != 0) {
                    if (ponto.cdGrandeza == "TE") {
                      item.te = ponto.vlMed;
                    } else if (ponto.cdGrandeza == "TD") {
                      item.td = ponto.vlMed;
                    } else if (ponto.cdGrandeza == "T_EXTERNA") {
                      item.t_externa = ponto.vlMed;
                    }
                  }
                } else {
                  if (ponto.vlMin != 0 && ponto.vlMax != 0) {
                    let rec = {
                      cdMedida: ponto.cdMedida,
                      data: ponto.dtGrandeza,
                      te: ponto.cdGrandeza == "TE" ? ponto.vlMed : null,
                      tMaxIdeal: ponto.vlIdeal + 1,
                      tMinIdeal: ponto.vlIdeal - 1,
                      td: ponto.cdGrandeza == "TD" ? ponto.vlMed : null,
                      t_externa:
                        ponto.cdGrandeza == "T_EXTERNA" ? ponto.vlMed : null,
                    };
                    context.listaTemperatura.push(rec);
                  }
                }
                if (ponto.cdGrandeza == "TE") {
                  teValues.push(ponto.vlMin);
                  teValues.push(ponto.vlMax);
                } else if (ponto.cdGrandeza == "TD") {
                  tdValues.push(ponto.vlMin);
                  tdValues.push(ponto.vlMax);
                } else if (ponto.cdGrandeza == "T_EXTERNA") {
                  tExternaValues.push(ponto.vlMin);
                  tExternaValues.push(ponto.vlMax);
                }
                tempIdealValues.push(ponto.vlIdeal);
              } else if (
                ponto.cdGrandeza == "CORTINA_DIREITA" &&
                (context.tipoAmbiencia == "CO" || context.tipoAmbiencia == "TD")
              ) {
                let rec = {
                  cdMedida: ponto.cdMedida,
                  data: ponto.dtGrandeza,
                  posicao: ponto.vlUltimo.toFixed(),
                  vlMax: ponto.vlMax.toFixed(),
                  vlMin: ponto.vlMin.toFixed(),
                };
                context.listaCortinaDireita.push(rec);
              } else if (
                ponto.cdGrandeza == "CORTINA_ESQUERDA" &&
                (context.tipoAmbiencia == "CO" || context.tipoAmbiencia == "TD")
              ) {
                let rec = {
                  cdMedida: ponto.cdMedida,
                  data: ponto.dtGrandeza,
                  posicao: ponto.vlUltimo.toFixed(),
                  vlMax: ponto.vlMax.toFixed(),
                  vlMin: ponto.vlMin.toFixed(),
                };
                context.listaCortinaEsquerda.push(rec);
              } else if (
                ponto.cdGrandeza == "UMIDADE" &&
                (context.tipoAmbiencia == "UM" || context.tipoAmbiencia == "TD")
              ) {
                let rec = {
                  cdMedida: ponto.cdMedida,
                  data: ponto.dtGrandeza,
                  h: ponto.vlMed,
                };
                context.listaUmidade.push(rec);
              } else if (
                ponto.cdGrandeza == "CO" &&
                (context.tipoAmbiencia == "GS" || context.tipoAmbiencia == "TD")
              ) {
                let rec = {
                  cdMedida: ponto.cdMedida,
                  data: ponto.dtGrandeza,
                  gMax: ponto.vlMax,
                  gMin: ponto.vlMin,
                };
                context.listaCO2.push(rec);
                gasMinValues.push(ponto.vlMin);
                gasMaxValues.push(ponto.vlMax);
              }
            });
          }
          context.listaTemperatura.sort((a, b) => {
            return new Date(a.data) - new Date(b.data);
          });
          context.listaCortinaDireita.sort((a, b) => {
            return new Date(a.data) - new Date(b.data);
          });
          context.listaCortinaEsquerda.sort((a, b) => {
            return new Date(a.data) - new Date(b.data);
          });
          context.listaUmidade.sort((a, b) => {
            return new Date(a.data) - new Date(b.data);
          });
          context.listaCO2.sort((a, b) => {
            return new Date(a.data) - new Date(b.data);
          });
          if (
            context.listaTemperatura.length > 0 &&
            (context.tipoAmbiencia == "TE" || context.tipoAmbiencia == "TD")
          ) {
            var tMax = {
              name: "Máxima",
              tMin: Math.min.apply(Math, tempIdealValues) + " °C",
              tMax: Math.max.apply(Math, tempIdealValues) + " °C",
              tMed:
                (
                  (Math.max.apply(Math, tempIdealValues) +
                    Math.min.apply(Math, tempIdealValues)) /
                  2
                ).toFixed(1) + " °C",
            };
            context.registrosTabelaTemperatura.push(tMax);
            var t_externa = {
              name: "Externa",
              tMin:
                tExternaValues.length != 0
                  ? Math.min.apply(Math, tExternaValues) + " °C"
                  : "--",
              tMax:
                tExternaValues.length != 0
                  ? Math.max.apply(Math, tExternaValues) + " °C"
                  : "--",
              tMed:
                tExternaValues.length != 0
                  ? (
                      (Math.max.apply(Math, tExternaValues) +
                        Math.min.apply(Math, tExternaValues)) /
                      2
                    ).toFixed(1) + " °C"
                  : "--",
            };
            context.registrosTabelaTemperatura.push(t_externa);
            var te = {
              name: "Esquerda",
              tMin: Math.min.apply(Math, teValues) + " °C",
              tMax: Math.max.apply(Math, teValues) + " °C",
              tMed:
                (
                  (Math.max.apply(Math, teValues) +
                    Math.min.apply(Math, teValues)) /
                  2
                ).toFixed(1) + " °C",
            };
            context.registrosTabelaTemperatura.push(te);
            var td = {
              name: "Direita",
              tMin: Math.min.apply(Math, tdValues) + " °C",
              tMax: Math.max.apply(Math, tdValues) + " °C",
              tMed:
                (
                  (Math.max.apply(Math, tdValues) +
                    Math.min.apply(Math, tdValues)) /
                  2
                ).toFixed(1) + " °C",
            };
            context.registrosTabelaTemperatura.push(td);
            var tMin = {
              name: "Mínima",
              tMin: Math.min.apply(Math, tempIdealValues) + " °C",
              tMax: Math.max.apply(Math, tempIdealValues) + " °C",
              tMed:
                (
                  (Math.max.apply(Math, tempIdealValues) +
                    Math.min.apply(Math, tempIdealValues)) /
                  2
                ).toFixed(1) + " °C",
            };
            context.registrosTabelaTemperatura.push(tMin);
          }
          if (
            context.listaCO2.length > 0 &&
            (context.tipoAmbiencia == "GS" || context.tipoAmbiencia == "TD")
          ) {
            var gMax = {
              name: "Máxima",
              gMin: Math.min.apply(Math, gasMaxValues) + " ppm",
              gMax: Math.max.apply(Math, gasMaxValues) + " ppm",
              gMed:
                (
                  (Math.max.apply(Math, gasMaxValues) +
                    Math.min.apply(Math, gasMaxValues)) /
                  2
                ).toFixed(0) + " ppm",
            };
            context.registrosTabelaCO2.push(gMax);
            var gMin = {
              name: "Mínima",
              gMin: Math.min.apply(Math, gasMinValues) + " ppm",
              gMax: Math.max.apply(Math, gasMinValues) + " ppm",
              gMed:
                (
                  (Math.max.apply(Math, gasMinValues) +
                    Math.min.apply(Math, gasMinValues)) /
                  2
                ).toFixed(0) + " ppm",
            };
            context.registrosTabelaCO2.push(gMin);
          }
          context.exibeGrafico = true;
        })
        .catch((error) => {
          this.$store.commit("setSnack", { type: "error", msg: error });
        });
    },
    getColorTemperatura(name) {
      if (name == "Esquerda") {
        return "#2196F3";
      } else if (name == "Direita") {
        return "#4CAF50";
      } else if (name == "Máxima") {
        return "#10303D";
      } else if (name == "Externa") {
        return "#9575CD";
      } else {
        return "#ff5429";
      }
    },
    getColorCO2(name) {
      if (name == "Máxima") {
        return "#10303D";
      } else {
        return "#ff5429";
      }
    },
    voltar() {
      this.$router.go(-1);
    },
  },
  watch: {
    $route(to) {
      this.changeFiltroAmbiencia();
    },
  },
  mounted() {
    this.changeFiltroAmbiencia();
  },
};
</script>

<style scoped>
.item {
  margin: 1px;
}
.marginTitle {
  margin: 15px;
}
.headerCard {
  color: white;
  background: #04222d;
  padding: 10px;
}
</style>
